<app-modal [title]="'Confirmar envio de e-mail'" (onCloseClick)="close()" (onSaveClick)="enviar()" [saveLabel]="'Enviar'"
    [hideCancel]="false" (onCancelClick)="close()">
    <div class="container">
        <div class="col-12">
            <p id="frase">{{frase}}</p>
            <p id="observacao">{{observacao}}</p>
        </div>
    </div>
</app-modal>